// Theme: clay-echo
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'clay-echo',
  name: 'CLAY ECHO',
  tagline: 'CLAY ECHO',
  description: 'Terracota calma com assinatura organica em versao free BP.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#2A1510', '#3A2018', '#C4856A', '#F2E0D8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 28%, transparent)'
    },
    shellClasses: 'font-mono theme-clay-echo'
  },
  colorVars: {
    '--accent': '#C4856A',
    '--accent-foreground': '#2A1510',
    '--background': '#2A1510',
    '--border': '#7A4A30',
    '--card': '#3A2018',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F2E0D8',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A1510',
    '--foreground': '#F2E0D8',
    '--hold-fill': '#C4856A',
    '--input': '#7A4A30',
    '--modal-bg': '#2A1510',
    '--modal-border': '#7A4A30',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#7A4A30',
    '--muted-foreground': '#F2E0D8',
    '--nav-active': '#C4856A',
    '--nav-bg': '#3A2018',
    '--popover': '#3A2018',
    '--popover-foreground': '#F2E0D8',
    '--primary': '#C4856A',
    '--primary-foreground': '#2A1510',
    '--ring': '#C4856A',
    '--secondary': '#7A4A30',
    '--secondary-foreground': '#F2E0D8',
    '--streak': '#C4856A',
    '--success': '#22c55e',
    '--success-foreground': '#2A1510',
    '--xp': '#C4856A',
    '--xp-bg': '#3A2018'
  },
  resolvedVars: {
    '--accent': '#C4856A',
    '--accent-foreground': '#2A1510',
    '--accent-foreground-hsl': '12 45% 11%',
    '--accent-foreground-oklch': 'from #2A1510 l c h',
    '--accent-hsl': '18 43% 59%',
    '--accent-oklch': 'from #C4856A l c h',
    '--background': '#2A1510',
    '--background-hsl': '12 45% 11%',
    '--background-oklch': 'from #2A1510 l c h',
    '--border': '#7A4A30',
    '--border-hsl': '21 44% 33%',
    '--border-oklch': 'from #7A4A30 l c h',
    '--border-w': '1px',
    '--card': '#3A2018',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F2E0D8',
    '--card-foreground-hsl': '18 50% 90%',
    '--card-foreground-oklch': 'from #F2E0D8 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '14 41% 16%',
    '--card-oklch': 'from #3A2018 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A1510',
    '--destructive-foreground-hsl': '12 45% 11%',
    '--destructive-foreground-oklch': 'from #2A1510 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F2E0D8',
    '--foreground-hsl': '18 50% 90%',
    '--foreground-oklch': 'from #F2E0D8 l c h',
    '--hold-fill': '#C4856A',
    '--hold-fill-hsl': '18 43% 59%',
    '--hold-fill-oklch': 'from #C4856A l c h',
    '--input': '#7A4A30',
    '--input-hsl': '21 44% 33%',
    '--input-oklch': 'from #7A4A30 l c h',
    '--modal-bg': '#2A1510',
    '--modal-bg-hsl': '12 45% 11%',
    '--modal-bg-oklch': 'from #2A1510 l c h',
    '--modal-border': '#7A4A30',
    '--modal-border-hsl': '21 44% 33%',
    '--modal-border-oklch': 'from #7A4A30 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#7A4A30',
    '--muted-foreground': '#F2E0D8',
    '--muted-foreground-hsl': '18 50% 90%',
    '--muted-foreground-oklch': 'from #F2E0D8 l c h',
    '--muted-hsl': '21 44% 33%',
    '--muted-oklch': 'from #7A4A30 l c h',
    '--nav-active': '#C4856A',
    '--nav-active-hsl': '18 43% 59%',
    '--nav-active-oklch': 'from #C4856A l c h',
    '--nav-bg': '#3A2018',
    '--nav-bg-hsl': '14 41% 16%',
    '--nav-bg-oklch': 'from #3A2018 l c h',
    '--popover': '#3A2018',
    '--popover-foreground': '#F2E0D8',
    '--popover-foreground-hsl': '18 50% 90%',
    '--popover-foreground-oklch': 'from #F2E0D8 l c h',
    '--popover-hsl': '14 41% 16%',
    '--popover-oklch': 'from #3A2018 l c h',
    '--primary': '#C4856A',
    '--primary-foreground': '#2A1510',
    '--primary-foreground-hsl': '12 45% 11%',
    '--primary-foreground-oklch': 'from #2A1510 l c h',
    '--primary-hsl': '18 43% 59%',
    '--primary-oklch': 'from #C4856A l c h',
    '--radius': '10px',
    '--ring': '#C4856A',
    '--ring-hsl': '18 43% 59%',
    '--ring-oklch': 'from #C4856A l c h',
    '--secondary': '#7A4A30',
    '--secondary-foreground': '#F2E0D8',
    '--secondary-foreground-hsl': '18 50% 90%',
    '--secondary-foreground-oklch': 'from #F2E0D8 l c h',
    '--secondary-hsl': '21 44% 33%',
    '--secondary-oklch': 'from #7A4A30 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 28%, transparent)',
    '--streak': '#C4856A',
    '--streak-hsl': '18 43% 59%',
    '--streak-oklch': 'from #C4856A l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2A1510',
    '--success-foreground-hsl': '12 45% 11%',
    '--success-foreground-oklch': 'from #2A1510 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(18 43% 59% / 0.15)',
    '--xp': '#C4856A',
    '--xp-bg': '#3A2018',
    '--xp-bg-hsl': '14 41% 16%',
    '--xp-bg-oklch': 'from #3A2018 l c h',
    '--xp-hsl': '18 43% 59%',
    '--xp-oklch': 'from #C4856A l c h'
  }
}
